import React, { useContext } from 'react'
import { motion } from 'framer-motion'

import { images } from '../../utilities'
import './Header.scss'
import Wrapper from '../../utilities/Wrapper'
import { DarkThemeContext } from '../../utilities/DarkTheme'

const scaleVariants = {
  whileInView: {
    scale: [0, 1],
    opacity: [0, 1],
    transition: {
      duration: 1,
      ease: 'easeInOut',
    },
  },
}

const circles = [images.react, images.redux, images.sass]
const Header = () => {
  const { darkToggle } = useContext(DarkThemeContext)
  return (
    <div className='app__header app__flex'>
      <motion.div
        whileInView={{ x: [-100, 0], opacity: [0, 1] }}
        transition={{ duration: 0.5 }}
        className='app__header-info'
      >
        <div className='app__header-badge'>
          <div className='badge-cmp app__flex dark:bg-slate-800'>
            <span>👋</span>
            <div style={{ marginLeft: 20 }}>
              <p className='p-text dark:text-slate-300'>Hello, I am</p>
              <h1 className='head-text dark:text-white'>Taha</h1>
            </div>
          </div>
          <div className='tag-cmp app__flex dark:bg-slate-800'>
            <p className='p-text dark:text-white'>Front End Developer</p>
          </div>
        </div>
      </motion.div>
      <motion.div
        whileInView={{ opacity: [0, 1] }}
        transition={{ duration: 0.5, delayChildren: 0.5 }}
        className='app__header-img'
      >
        <img src={images.profile} alt='taha ebaed profile avatar' />
        <motion.img
          whileInView={{ opacity: [0, darkToggle ? 0.28 : 1] }}
          transition={{ duration: 1, ease: 'easeInOut' }}
          src={images.circle}
          alt='profile_circle'
          className='overlay_circle '
        />
      </motion.div>
      <motion.div
        variants={scaleVariants}
        whileInView={scaleVariants.whileInView}
        className='app__header-circles'
      >
        {circles.map((circle, index) => (
          <div
            className='circle-cmp app__flex dark:bg-slate-800'
            key={`circle-${index}`}
          >
            <img src={circle} alt='circle' />
          </div>
        ))}
      </motion.div>
    </div>
  )
}

export default Wrapper(Header, 'home', 'dark:bg-slate-900')
